import {
  ActionReducer,
  ActionReducerMap,
  createSelector,
  MetaReducer,
} from "@ngrx/store";
import { authReducer, AuthState } from "app/modules/auth/_state/auth.reducers";
import { environment } from "environments/environment";
import { logout } from "../modules/auth/_state/auth.actions";
import { sharedReducer, SharedState } from "../shared/_state/shared.reducer";
import { DashboardReducer, DashboardState } from "app/modules/dashboard/_state/dashboard.reducers";


export interface AppState {
  auth: AuthState;
  shared: SharedState;
  dashboard: DashboardState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  shared: sharedReducer,
  dashboard: DashboardReducer
};

export function flush(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === logout.type) {
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}

// Auth
export const selectAuthState = (state: AppState) => state.auth;



// Shared
export const selectSharedState = (state: AppState) => state.shared;
export const selectCountries = createSelector(
  selectSharedState,
  (state: SharedState) => state.countries
);
export const selectCountriesLoading = createSelector(
  selectSharedState,
  (state: SharedState) => state.loadingCountries
);
export const selectCountriesError = createSelector(
  selectSharedState,
  (state: SharedState) => state.countriesError
);

//Dashboard
export const selectDashboardState = (state: AppState) => state.dashboard;
export const selectBroadcast = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allBroadcasts
);
export const selectBroadcastLoading = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allBroadcastsLoading
);
export const selectBroadcastError = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allBroadcastsError
);

/**pastors */
export const selectPastor = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allPastors
);
export const selectPastorLoading = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allPastorsLoading
);
export const selectPastorError = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allPastorsError
);

/**jobs */
export const selectJob = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allJobs
);
export const selectJobLoading = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allJobsLoading
);
export const selectJobError = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.allJobsError
);





export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? [flush]
  : [flush];
